var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.9395C9.02344 12.9395 11.0391 11.7969 11.0391 10.1797V3.08984C11.0391 1.61328 9.02344 0.59375 6 0.59375C2.97656 0.59375 0.960938 1.61328 0.960938 3.08984V10.1797C0.960938 11.7969 2.97656 12.9395 6 12.9395ZM6 4.69531C3.54492 4.69531 1.9043 4.0332 1.9043 3.08984C1.9043 2.10547 3.54492 1.41992 6 1.41992C8.45508 1.41992 10.0957 2.10547 10.0957 3.08984C10.0957 4.0332 8.45508 4.69531 6 4.69531ZM6 5.58008C7.78711 5.58008 9.22266 5.22852 10.0957 4.63086V7.29688C9.12891 7.92383 7.56445 8.33398 6 8.33398C4.43555 8.33398 2.87109 7.92383 1.9043 7.29688V4.63086C2.77734 5.22852 4.21289 5.58008 6 5.58008ZM6 9.21875C7.53516 9.21875 9.05273 8.86133 10.0957 8.29297V10.1797C10.0957 11.2637 8.45508 12.0547 6 12.0547C3.54492 12.0547 1.9043 11.2637 1.9043 10.1797V8.29297C2.94727 8.86133 4.45898 9.21875 6 9.21875Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.3c0498c830886760d49fd59ce20c1d65.svg";
export { ForwardRef as ReactComponent };